import { useEffect, useRef } from "react";
import { gsap, ScrollTrigger, prefersReducedMotion } from "@/lib/gsapSetup";

/**
 * Reusable scroll reveal. Children with [data-reveal] animate up + fade in with
 * a stagger. Respects prefers-reduced-motion (falls back to opacity only).
 */
export default function useScrollReveal(options = {}) {
  const ref = useRef(null);
  const { selector = "[data-reveal]", y = 40, stagger = 0.08, start = "top 85%" } = options;

  useEffect(() => {
    const scope = ref.current;
    if (!scope) return undefined;

    const targets = scope.querySelectorAll(selector);
    if (!targets.length) return undefined;

    const reduced = prefersReducedMotion();

    const ctx = gsap.context(() => {
      gsap.set(targets, { opacity: 0, y: reduced ? 0 : y });
      gsap.to(targets, {
        opacity: 1,
        y: 0,
        duration: reduced ? 0.6 : 1,
        ease: "power3.out",
        stagger,
        scrollTrigger: { trigger: scope, start },
      });
    }, scope);

    return () => ctx.revert();
  }, [selector, y, stagger, start]);

  return ref;
}
